<script setup lang="ts">
import { formatDate, getTimeDifference } from '@/tools/tools'

const props = defineProps<{
  statData: any
}>()

const date_create = props.statData[0]?.date_create
const date_assembl = props.statData[0]?.date_assembl
const date_completed = props.statData[0]?.date_completed
const date_on_way = props.statData[0]?.date_on_way
const date_delivered = props.statData[0]?.date_delivered
</script>

<template>
  <div class="statistic-wrapper">
    <!-- Первая секция -->
    <div class="first-section">
      <div class="left">
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          :style="{ fill: 'var(--orange-color)', marginTop: '7px' }"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="5" cy="5" r="5"/>
        </svg>
        <img src="@/assets/line.svg" alt="line">
      </div>
      <div class="right">
        <p class="date-create">Создан: {{ formatDate(date_create) }}</p>
      </div>
    </div>

    <!-- Между создан и начали собирать -->
    <div v-if="date_assembl" class="between">
      {{ getTimeDifference(date_create, date_assembl) }}
    </div>

    <!-- Начали собирать -->
    <div v-if="date_assembl" class="second-section" :style="{ alignItems: 'center' }">
      <div class="left">
        <img src="@/assets/line.svg" alt="line">
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          :style="{ fill: 'var(--orange-color)' }"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="5" cy="5" r="5"/>
        </svg>
        <img src="@/assets/line.svg" alt="line">
      </div>
      <div class="right">
        <p class="date-create">Начали собирать: {{ formatDate(date_assembl) }}</p>
      </div>
    </div>

    <!-- Между начали собирать и собрали -->
    <div v-if="date_completed" class="between">
      {{ getTimeDifference(date_assembl, date_completed) }}
    </div>

    <!-- Собрали -->
    <div v-if="date_completed" class="second-section" :style="{ alignItems: 'center' }">
      <div class="left">
        <img src="@/assets/line.svg" alt="line">
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          :style="{ fill: 'var(--orange-color)' }"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="5" cy="5" r="5"/>
        </svg>
        <img src="@/assets/line.svg" alt="line">
      </div>
      <div class="right">
        <p class="date-create">Собрали: {{ formatDate(date_completed) }}</p>
      </div>
    </div>

    <!-- Между собрали и поехал -->
    <div v-if="date_on_way" class="between">
      {{ getTimeDifference(date_completed, date_on_way) }}
    </div>

    <!-- Поехал -->
    <div v-if="date_on_way" class="second-section" :style="{ alignItems: 'center' }">
      <div class="left">
        <img src="@/assets/line.svg" alt="line">
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          :style="{ fill: 'var(--orange-color)' }"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="5" cy="5" r="5"/>
        </svg>
        <img src="@/assets/line.svg" alt="line">
      </div>
      <div class="right">
        <p class="date-create">Поехал: {{ formatDate(date_on_way) }}</p>
      </div>
    </div>

    <!-- Между поехал и доставили -->
    <div v-if="date_delivered" class="between">
      {{ getTimeDifference(date_on_way, date_delivered) }}
    </div>

    <!-- Доставили -->
    <div v-if="date_delivered" class="second-section" :style="{ alignItems: 'end' }">
      <div class="left">
        <img src="@/assets/line.svg" alt="line">
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          :style="{ fill: 'var(--green-color)' }"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="5" cy="5" r="5"/>
        </svg>
      </div>
      <div class="right">
        <p class="date-create">Доставили: {{ formatDate(date_delivered) }}</p>
      </div>
    </div>
  </div>
</template>

<style scoped>


.between{
  background-color: var(--grey-color);
  font-size: 18px;
  font-weight: 500;
  padding: 5px 10px;
  margin-top: 10px;
  border-radius: var(--border-radius);
  width: 100%;
  box-sizing: border-box;
  text-align: start;
}

.date-create{
  font-size: 18px;
  font-weight: 500;
}

.right{
  display: flex;
}

.left{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.first-section, .second-section{
  display: flex;
  align-items: start;
  width: 100%;
  justify-content: start;
  gap: 10px;
  margin-top: 10px;
}

.statistic-wrapper{
  color: black;
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  align-self: start;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  background-color: white;
  border-radius: var(--border-radius);
  box-shadow: var(--drop-shadow-item);
  padding: 20px;
}

</style>